import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { OrganizationState, OrganizationType } from './organizationTypes'

const initialState: OrganizationState = {
  selectedOrganization: null,
  organizations: []
}

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setSelectedOrganization(
      state,
      action: PayloadAction<OrganizationState['selectedOrganization']>
    ) {
      state.selectedOrganization = action.payload
    },
    setOrganizations(state, action: PayloadAction<OrganizationType[]>) {
      state.organizations = action.payload
    }
  }
})

export const organizationReducer = organizationSlice.reducer
